<template lang="pug">
  div
    page_header(title="Challenges", subhead="Edit")
      router-link.btn.btn-primary.ml-3.d-none.d-sm-inline-block(:to='{name: "challenges.index"}')
        i.feather-arrow-left
        | Back
    
    .row
      .col-sm-12
        form.card(@submit.prevent="submit" :class="sending?'loading':''")
          .card-body.border-bottom.p-5
            .row
              .col-sm-6
                form_input(type="text" name="title" label="Title" placeholder="Challenge Title" v-model="form.title" :required="true")  

                .row    
                  .col-sm-6 
                    //- form_input(type="text" name="sector" label="Sector" placeholder="Enter Sector" v-model="form.sector")
                    form_select(name="sector" label="Sector" placeholder="Sector" v-model="form.sector" :options="domains" :required="true")
                  .col-sm-6
                    //- form_input(type="date" name="expiry" label="Expiry" placeholder="Enter Expiry" v-model="form.expiry")
                    .mb-3
                      label.form-label Expiry
                      datepicker(v-model="form.expiry" format="YYYY-MM-DD HH:mm" :no-label="true")

                .row
                  .col-sm-6
                    form_select(name="entity" label="Entity Type" placeholder="Entity Type" v-model="form.entity_type" :options="['industries','associations','corporates']" :required="true")
                  .col-sm-6
                    form_select(name="entity_id" label="Select Enity" placeholder="Select Entity" v-model="form.entity_id" :options="selected_entity" :item="{value:'id', label:'name'}" :required="true")
                  
                
              .col-sm-6      
                .mb-3
                  label.form-label Eligibility
                  textarea.form-control(name="eligibility" rows="5" placeholder="Eligibility" v-model="form.eligibility" :required="true")
     
                .row
                  .col-sm-6
                    form_select(name="application_type" label="Application Type" placeholder="Application Type" v-model="form.application_type" :options="['external', 'internal','custom']" :required="true")
                  .col-sm-6
                    form_select(name="status" label="Status" placeholder="status" v-model="form.status" :options="['active','inactive']" :required="true")
                
            .row
              .col-sm-6
                form_input(type="text" name="video" label="Video" placeholder="Video" v-model="form.video" )  
              .col-sm-6
                form_input(type="text" name="application_link" label="Application Link" placeholder="Enter Application Link" v-model="form.application_link" v-if="form.application_type=='external'")
                form_input(type="text" name="form" label="Form ID" placeholder="Enter Form ID" v-model="form.form_id" v-if="form.application_type=='custom'")

                .mt-3(v-if="form.application_type=='internal'")
                  label.form-check.form-switch
                    input.form-check-input(type='checkbox' v-model="form.restrict")
                    span.form-check-label Restrict to UID Startups
                    
            .row
              .col-sm-12
                .mb-3
                  label.form-label Challenges Description
                  summernote#summernote(ref="summernote" name="summernote" :html="form.brief" :airmode="false")

            .row(v-if="form.application_type=='internal'")
              .col-sm-6
                form_input(type="text" name="drive" label="Google Drive Folder ID" placeholder="Google Drive Folder ID" v-model="form.drive" :required="true")  
                .text-small.text-muted
                  | https://drive.google.com/drive/folders/&lt;Google Drive Folder ID&gt;
                .text-small.text-muted
                  | Copy the folder id part alone
                .text-small.text-muted
                  | Share files with notifications@startupmission.in
              //- .col-sm-6
              //-   form_input(type="text" name="sheet" label="Google Sheet ID" placeholder="Google Sheet ID" v-model="form.sheet" :required="true")
              //-   .text-small.text-muted
              //-     | Make copy of the  
              //-     a.text-small(href="https://docs.google.com/spreadsheets/d/11RxV0V1o09rIXu-Bb8ERq7et5MssIg2cng9MmRiloAo/edit?usp=sharing" target="_blank") Template 
              //-   .text-small.text-muted
              //-     | Share the file with cross-sell@cross-sell-280112.iam.gserviceaccount.com
              //-   .text-small.text-muted
              //-     | https://docs.google.com/spreadsheets/d/&lt;Google Sheet ID&gt;/edit#gid=0
              //-   .text-small.text-muted
              //-     | Copy the google sheet id part alone
              //- .col-sm-2
              //-   form_input(type="text" name="tab" label="Google Sheet Tab Name" placeholder="Google Sheet Tab Name" v-model="form.tab" :required="true")


            .d-flex.align-items-center
              //- a.btn.btn-link Back
              loadingBtn.ml-auto(type="submit" :disabled='sending') Save

  
      

</template>

<script>
// @ is an alias to /src

import page_header from '@/components/pageHeader'
import form_input from '@/components/formInput'
import loadingBtn from '@/components/loadingBtn'
import form_select from '@/components/formSelect'
import imageSelect from '@/components/imageSelect'
import summernote from '@/components/summernote';
import { mapActions, mapState } from 'vuex'

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

export default {
  name: 'Challengess',
  props: ['id'],
  components: {
    page_header: page_header,
    form_input,
    form_select,
    loadingBtn,
    imageSelect,
    summernote,
    datepicker: VueCtkDateTimePicker
  },
  data(){
    return {
      domains: [],
      industries: [],
      associations: [],
      corporates: [],
      form: {
        sector: ''
      }
    }
  },
  computed: {
    selected_entity(){
      if(this.form.entity_type){
        return this[this.form.entity_type];
      }
      else{
        return []
      }
    },
    ...mapState('api', ['errors', 'sending'])
  },
  methods:{
    submit(){
      var vm = this;
      vm.form.description = this.$refs.summernote.getVal();
      this.call({_vm:this, endpoint: 'admin/challenge/'+this.id, method: 'PUT', data: this.form})
    },
    ...mapActions('api', ['call'])
  },
  mounted(){
    var vm = this;
    this.call({_vm: vm, endpoint: `admin/challenge/${this.id}/edit`, method: 'GET'}).then(async (response)=>{
      vm.domains = response.domains;
      vm.industries = response.industries;
      vm.associations = response.associations;
      vm.corporates = response.corporate;

      // vm.$nextTick(()=>{
        await vm.$nextTick();
        vm.form = response.data;
        var entity = response.data.entity_id;
        vm.form.entity_id = '';
        await vm.$nextTick();
        vm.form.sector = response.data.sector;
        vm.form.application_type = response.data.application_type;
        vm.form.entity_id = entity;
        vm.$refs.summernote.setVal(response.data.description);
      // })

    })
  }
}
</script>

<style lang="scss">
.field-input{
  min-height:36px !important;
  height:36px !important;
}
</style>